var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrame3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 70,
    viewBox: "0 0 80 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8386 6.69282C10.0378 7.30904 9.55532 8.29284 9.56559 9.34149V51.504C9.56559 52.7365 10.2226 53.85 11.2697 54.4014L29.348 63.915V11.7848L13.6206 6.26038C12.6864 5.92525 11.6496 6.08741 10.8386 6.69282Z",
    fill: "#CDA876"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3945 65.435H32.4645L47.6119 57.2211V4.56543L32.3945 12.801V65.435Z",
    fill: "#CDA876"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7499 15.7166L50.6514 6.08496V58.1582L66.4267 63.7452C68.0195 64.3061 69.7441 63.4001 70.2818 61.6959C70.3832 61.3724 70.434 61.0272 70.434 60.6821V18.6179C70.434 17.3884 69.7847 16.2666 68.7499 15.7166Z",
    fill: "#CDA876"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame3);
export default __webpack_public_path__ + "static/media/frame_3.3680b04478391504ba32b9e50b1fb356.svg";
export { ForwardRef as ReactComponent };